import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ConsumableEditForm from '@components/shared/consumables/ConsumableEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useOperatorConsumableService from '@hooks/operator/consumables/useOperatorConsumableService';
import { useParams } from 'react-router-dom';

function ConsumableEditWrapper() {
  const { id } = useParams();
  const consumableService = useOperatorConsumableService();
  const { volumeUnit } = useOperatorData();

  return (
    <ConsumableEditForm
      loadConsumable={consumableService.get}
      createConsumable={consumableService.create}
      updateConsumable={consumableService.update}
      volumeUnit={volumeUnit}
      consumableId={id}
      role="operator"
    />
  );
}

export default function ConsumableEdit() {
  const { id } = useParams();

  return id ? (
    // 編輯模式：直接渲染
    <ConsumableEditWrapper />
  ) : (
    // 新增模式：先選擇 merchant
    <MerchantSelect>
      <ConsumableEditWrapper />
    </MerchantSelect>
  );
}
